import React from 'react';

import {
	Icon,
	styled
} from 'ps-gui';

const Wrapper = styled.a`
	font-size: 16px;
	font-weight: 500;
	text-decoration: none;
	vertical-align: middle;
	position: relative;
	&:hover {
		text-decoration: underline;
	}
	.icon {
		margin-right: 4px;
		position: relative;
		top: -1px;
	}
	color: ${props => props.theme.textColor};
	margin: ${props => props.margin};

	&.light {
		font-weight: 300;
	}
`;


export default class EmailAddress extends React.PureComponent {
	render() {
		let value = this.props.value;
		if (this.props.preset === 'intergram') {
			value = 'portal@intergram.cz';
		}
		if (!value) {
			return null;
		}
		return (
			<Wrapper href={'mailto:' + value} margin={this.props.margin} className={'emailAddress ' + (this.props.light ? 'light' : 'normal')}>
				<Icon
					name="email"
				/>
				{value}
			</Wrapper>
		);
	}
}
